import React from "react";

import { BPComparison, BigPictureDashBoardPieChartInput, BigPictureDashBoardPieChartLegend, Common, Gender } from "../../helper";
import { capitalizeFirstLetter } from "../../util";

const CheckAppliedFilter = (setSelectedComparision, compSelected, setSelectedFilter, selectedClassName, pupilProgress) => {
  setSelectedComparision(compSelected);
  let selection = [];

  if (pupilProgress.subjectName !== Common.All) selection = [...selection, pupilProgress.subjectName];
  if (pupilProgress.male) selection = [...selection, Gender.Male];
  if (pupilProgress.female) selection = [...selection, Gender.Female];
  if (pupilProgress.EAL) selection = [...selection, Common.Eal];
  if (pupilProgress.PP) selection = [...selection, Common.PP];
  if (pupilProgress.notEAL) selection = [...selection, Common.NotEal];
  if (pupilProgress.notPP) selection = [...selection, Common.NotPp];

  // Check if all three conditions are true
  if (pupilProgress.ehcp && pupilProgress.notSen && pupilProgress.sendSupport) {
    selection = [...selection];
  } else if (pupilProgress.ehcp && pupilProgress.sendSupport) {
    selection = [...selection, Common.AllSend];
  } else {
    // Include individual selections based on conditions
    if (pupilProgress.ehcp) selection = [...selection, Common.Ehcp];
    if (pupilProgress.notSen) selection = [...selection, Common.NotSend];
    if (pupilProgress.sendSupport) selection = [...selection, Common.SenSupport];
  }

  if (pupilProgress.classId !== Common.All) selection = [...selection, selectedClassName];
  if (pupilProgress.pupilYear.length !== 6) selection = [...selection, pupilProgress.pupilYear];

  setSelectedFilter(selection);
};

const ComparisonNames = (str) => {
  let name = "";
  switch (str) {
  case BPComparison.PP: name = `${BigPictureDashBoardPieChartLegend.PupilPremium} Status`;
    break;
  case BPComparison.SEND: name = BigPictureDashBoardPieChartLegend.Send_;
    break;
  case BPComparison.EAL: name = BigPictureDashBoardPieChartLegend.Eal_;
    break;
  case BPComparison.GLD: name = "Good Level of Development and Key Stage 1 Outcomes";
    break;
  default: name = str;
    break;
  }
  return name
}

const FillColor = (input) => {
  let background = "";
  switch (input) {
  case BigPictureDashBoardPieChartInput.Male: case BigPictureDashBoardPieChartInput.NotPupilPremium: case BigPictureDashBoardPieChartInput.NotEyfs: case BigPictureDashBoardPieChartInput.NotEyfs_: case BigPictureDashBoardPieChartInput.NotSend: case BigPictureDashBoardPieChartInput.NotPP: case BigPictureDashBoardPieChartInput.Fsm: case BigPictureDashBoardPieChartInput.NotEal: background = "var(--male-color)";
    break;
  case BigPictureDashBoardPieChartInput.Female: case BigPictureDashBoardPieChartInput.Lea: case BigPictureDashBoardPieChartInput.Send_: background = "var(--female-color)";
    break;
  case BigPictureDashBoardPieChartInput.Unspecified: case BigPictureDashBoardPieChartInput.PupilPremium: case BigPictureDashBoardPieChartInput.PP: case BigPictureDashBoardPieChartInput.Eyfs: case BigPictureDashBoardPieChartInput.Eyfs_: case BigPictureDashBoardPieChartInput.Send: case BigPictureDashBoardPieChartInput.Fsm6: case BigPictureDashBoardPieChartInput.Eal: background = "var(--unspecified-color)";
    break;
  case BigPictureDashBoardPieChartInput.Ehcp: case BigPictureDashBoardPieChartInput.Ehcp_: background = "var(--ehcp-color)";
    break;
  case BigPictureDashBoardPieChartInput.KsBelow: background = "var(--below-colour)";
    break;
  case BigPictureDashBoardPieChartInput.KsHigh: background = "var(--greater-colour)";
    break;
  case BigPictureDashBoardPieChartInput.KsLow: case BigPictureDashBoardPieChartInput.KsHnm: background = "var(--emerging-colour)";
    break;
  case BigPictureDashBoardPieChartInput.KsUnknown: background = "var(--absent-colour)";
    break;
  case BigPictureDashBoardPieChartInput.KsExs: case BigPictureDashBoardPieChartInput.KsMiddle: background = "var(--expected-colour)";
    break;
  case BigPictureDashBoardPieChartInput.Year1: background = "var(--female-color)";
    break
  case BigPictureDashBoardPieChartInput.Year2: background = "var(--male-color)";
    break;
  case BigPictureDashBoardPieChartInput.Year3: background = "var(--unspecified-color)";
    break;
  case BigPictureDashBoardPieChartInput.Year4: background = "var(--ehcp-color)";
    break;
  case BigPictureDashBoardPieChartInput.Year5: background = "var(--greater-colour)";
    break;
  case BigPictureDashBoardPieChartInput.Year6: background = "var(--emerging-colour)";
    break;
  default: background = "var(--white-color)";
    break;
  }
  return background;
}

const mapPupilYearToLabel = (year) => {
  return `${Common.Year} ${year}`;
};

const FilterNames = (selectedFilter) => {
  return (<>
    {selectedFilter?.length > 0 ? (
      selectedFilter?.map((filter, index, array) => (
        <span key={index}>
          {Array.isArray(filter) ? (
            filter.map((year, yearIndex) => (
              <span key={yearIndex}>{mapPupilYearToLabel(year)}{yearIndex !== filter.length - 1 && ", "}</span>
            ))
          ) : (
            // filter?.toUpperCase()
            filter ? capitalizeFirstLetter(filter):""
          )}
          {index !== array.length - 1 && ", "}
          {index === array.length - 1 && " Pupils"}
        </span>
      ))
    ) : (
      <span>{Common.None}</span>
    )}
  </>)
}

const SpecifyName = (input) => {
  let name = "";
  switch (input) {
  case BigPictureDashBoardPieChartInput.Male: name = BigPictureDashBoardPieChartLegend.Male;
    break;
  case BigPictureDashBoardPieChartInput.Female: name = BigPictureDashBoardPieChartLegend.Female;
    break;
  case BigPictureDashBoardPieChartInput.Unspecified: name = BigPictureDashBoardPieChartLegend.Unspecified;
    break;
  case BigPictureDashBoardPieChartInput.PupilPremium: case BigPictureDashBoardPieChartInput.PP: name = BigPictureDashBoardPieChartLegend.PupilPremium
    break;
  case BigPictureDashBoardPieChartInput.NotPupilPremium: case BigPictureDashBoardPieChartInput.NotPP: name = BigPictureDashBoardPieChartLegend.NotPupilPremium;
    break;
  case BigPictureDashBoardPieChartInput.Eyfs: case BigPictureDashBoardPieChartInput.Eyfs_: name = BigPictureDashBoardPieChartLegend.Eyfs
    break;
  case BigPictureDashBoardPieChartInput.NotEyfs: case BigPictureDashBoardPieChartInput.NotEyfs_: name = BigPictureDashBoardPieChartLegend.NotEyfs
    break;
  case BigPictureDashBoardPieChartInput.Send: name = BigPictureDashBoardPieChartLegend.Send
    break;
  case BigPictureDashBoardPieChartInput.NotSend: name = BigPictureDashBoardPieChartLegend.NotSend
    break;
  case BigPictureDashBoardPieChartInput.Ehcp: case BigPictureDashBoardPieChartInput.Ehcp_: name = BigPictureDashBoardPieChartLegend.Ehcp
    break;
  case BigPictureDashBoardPieChartInput.Lea: name = BigPictureDashBoardPieChartLegend.Lea
    break;
  case BigPictureDashBoardPieChartInput.Fsm: name = BigPictureDashBoardPieChartLegend.Fsm
    break;
  case BigPictureDashBoardPieChartInput.Fsm6: name = BigPictureDashBoardPieChartLegend.Fsm6
    break;
  case BigPictureDashBoardPieChartInput.Eal: name = BigPictureDashBoardPieChartLegend.Eal
    break;
  case BigPictureDashBoardPieChartInput.NotEal: name = BigPictureDashBoardPieChartLegend.NotEal
    break;
  case BigPictureDashBoardPieChartInput.KsHigh: name = BigPictureDashBoardPieChartLegend.KsHigh
    break;
  case BigPictureDashBoardPieChartInput.KsMiddle: name = BigPictureDashBoardPieChartLegend.KsMiddle
    break;
  case BigPictureDashBoardPieChartInput.KsLow: name = BigPictureDashBoardPieChartLegend.KsLow
    break;
  case BigPictureDashBoardPieChartInput.KsBelow: name = BigPictureDashBoardPieChartLegend.KsBelow
    break;
  case BigPictureDashBoardPieChartInput.KsUnknown: name = BigPictureDashBoardPieChartLegend.KsUnknown
    break;
  case BigPictureDashBoardPieChartInput.KsExs: name = BigPictureDashBoardPieChartLegend.KsExs
    break;
  case BigPictureDashBoardPieChartInput.KsHnm: name = BigPictureDashBoardPieChartLegend.KsHnm
    break;
  case BigPictureDashBoardPieChartInput.Year1: name = BigPictureDashBoardPieChartLegend.Year1
    break;
  case BigPictureDashBoardPieChartInput.Year2: name = BigPictureDashBoardPieChartLegend.Year2
    break;
  case BigPictureDashBoardPieChartInput.Year3: name = BigPictureDashBoardPieChartLegend.Year3
    break;
  case BigPictureDashBoardPieChartInput.Year4: name = BigPictureDashBoardPieChartLegend.Year4
    break;
  case BigPictureDashBoardPieChartInput.Year5: name = BigPictureDashBoardPieChartLegend.Year5
    break;
  case BigPictureDashBoardPieChartInput.Year6: name = BigPictureDashBoardPieChartLegend.Year6
    break;
  case BigPictureDashBoardPieChartInput.Send_: name = BigPictureDashBoardPieChartLegend.Send_
    break;
  default: name = input
    break;
  }
  return name;
}

const SpecifyPieChartName = (str) => {
  let name = "";
  switch (str) {
  case BigPictureDashBoardPieChartInput.AllPupil: name = BigPictureDashBoardPieChartLegend.AllPupil;
    break;
  case BigPictureDashBoardPieChartInput.AllPupilPre: name = BigPictureDashBoardPieChartLegend.AllPupilPre;
    break;
  case BigPictureDashBoardPieChartInput.PupilPremium: name = BigPictureDashBoardPieChartLegend.PupilPremium;
    break;
  case BigPictureDashBoardPieChartInput.Gender: name = BigPictureDashBoardPieChartLegend.Gender;
    break;
  case BigPictureDashBoardPieChartInput.Eal_: case BigPictureDashBoardPieChartInput.Eal: name = BigPictureDashBoardPieChartLegend.Eal_;
    break;
  case BigPictureDashBoardPieChartInput.Gld: name = BigPictureDashBoardPieChartLegend.Gld;
    break;
  case BigPictureDashBoardPieChartInput.Ks1Maths: name = BigPictureDashBoardPieChartLegend.Ks1Maths;
    break;
  case BigPictureDashBoardPieChartInput.Ks1Reading: name = BigPictureDashBoardPieChartLegend.Ks1Reading;
    break;
  case BigPictureDashBoardPieChartInput.Ks1Science: name = BigPictureDashBoardPieChartLegend.Ks1Science;
    break;
  case BigPictureDashBoardPieChartInput.Ks1Writing: name = BigPictureDashBoardPieChartLegend.Ks1Writing;
    break;
  case BigPictureDashBoardPieChartInput.SendStatus: name = BigPictureDashBoardPieChartLegend.SendStatus;
    break;
  case BigPictureDashBoardPieChartInput.PpStatus: case BigPictureDashBoardPieChartInput.Pp: name = BigPictureDashBoardPieChartLegend.PpStatus;
    break;
  case BigPictureDashBoardPieChartInput.FreeSchoolMeals: name = BigPictureDashBoardPieChartLegend.FreeSchoolMeals;
    break;
  case BigPictureDashBoardPieChartInput.FreeSchoolMeals6: name = BigPictureDashBoardPieChartLegend.FreeSchoolMeals6;
    break;
  case BigPictureDashBoardPieChartInput.Lea: name = BigPictureDashBoardPieChartLegend.Lea;
    break;
  case BigPictureDashBoardPieChartInput.NotPupilPremium: name = BigPictureDashBoardPieChartLegend.NotPupilPremium;
    break;
  case BigPictureDashBoardPieChartInput.Male: name = BigPictureDashBoardPieChartLegend.Male;
    break;
  case BigPictureDashBoardPieChartInput.Female: name = BigPictureDashBoardPieChartLegend.Female;
    break;
  case BigPictureDashBoardPieChartInput.Unspecified: case BigPictureDashBoardPieChartInput.Notspecified: name = BigPictureDashBoardPieChartLegend.Unspecified;
    break;
  case BigPictureDashBoardPieChartInput.Year1: name = BigPictureDashBoardPieChartLegend.Year1
    break;
  case BigPictureDashBoardPieChartInput.Year2: name = BigPictureDashBoardPieChartLegend.Year2
    break;
  case BigPictureDashBoardPieChartInput.Year3: name = BigPictureDashBoardPieChartLegend.Year3
    break;
  case BigPictureDashBoardPieChartInput.Year4: name = BigPictureDashBoardPieChartLegend.Year4
    break;
  case BigPictureDashBoardPieChartInput.Year5: name = BigPictureDashBoardPieChartLegend.Year5
    break;
  case BigPictureDashBoardPieChartInput.Year6: name = BigPictureDashBoardPieChartLegend.Year6
    break;
  case BigPictureDashBoardPieChartInput.Send_: name = BigPictureDashBoardPieChartLegend.Send_
    break;
  case BigPictureDashBoardPieChartInput.NotEal: name = BigPictureDashBoardPieChartLegend.NotEal
    break;
  case BigPictureDashBoardPieChartInput.Send: name = BigPictureDashBoardPieChartLegend.Send
    break;
  case BigPictureDashBoardPieChartInput.Ehcp: name = BigPictureDashBoardPieChartLegend.Ehcp
    break;
  case BigPictureDashBoardPieChartInput.AllSend: case BigPictureDashBoardPieChartInput.AllSend_: name = BigPictureDashBoardPieChartLegend.AllSend
    break;
  case BigPictureDashBoardPieChartInput.NotSend: name = BigPictureDashBoardPieChartLegend.NotSend
    break;
  case BigPictureDashBoardPieChartInput.AllKs1MathsPupil: name = BigPictureDashBoardPieChartLegend.AllKs1MathsPupil
    break;
  case BigPictureDashBoardPieChartInput.AllKs1ReadingPupil: name = BigPictureDashBoardPieChartLegend.AllKs1ReadingPupil
    break;
  case BigPictureDashBoardPieChartInput.AllKs1SciencePupil: name = BigPictureDashBoardPieChartLegend.AllKs1SciencePupil
    break;
  case BigPictureDashBoardPieChartInput.AllKs1WritingPupil: name = BigPictureDashBoardPieChartLegend.AllKs1WritingPupil
    break;
  case BigPictureDashBoardPieChartInput.NotGld: name = BigPictureDashBoardPieChartLegend.NotGld
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1Below: name = BigPictureDashBoardPieChartLegend.MathsKs1Below
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1High: name = BigPictureDashBoardPieChartLegend.MathsKs1High
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1Low: name = BigPictureDashBoardPieChartLegend.MathsKs1Low
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1Middle: name = BigPictureDashBoardPieChartLegend.MathsKs1Middle
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1Unknown: name = BigPictureDashBoardPieChartLegend.MathsKs1Unknown
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1Below: name = BigPictureDashBoardPieChartLegend.ReadingKs1Below
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1High: name = BigPictureDashBoardPieChartLegend.ReadingKs1High
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1Low: name = BigPictureDashBoardPieChartLegend.ReadingKs1Low
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1Middle: name = BigPictureDashBoardPieChartLegend.ReadingKs1Middle
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1Unknown: name = BigPictureDashBoardPieChartLegend.ReadingKs1Unknown
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1Below: name = BigPictureDashBoardPieChartLegend.WritingKs1Below
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1High: name = BigPictureDashBoardPieChartLegend.WritingKs1High
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1Low: name = BigPictureDashBoardPieChartLegend.WritingKs1Low
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1Middle: name = BigPictureDashBoardPieChartLegend.WritingKs1Middle
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1Unknown: name = BigPictureDashBoardPieChartLegend.WritingKs1Unknown
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1Below: name = BigPictureDashBoardPieChartLegend.ScienceKs1Below
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1High: name = BigPictureDashBoardPieChartLegend.ScienceKs1High
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1Low: name = BigPictureDashBoardPieChartLegend.ScienceKs1Low
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1Middle: name = BigPictureDashBoardPieChartLegend.ScienceKs1Middle
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1Unknown: name = BigPictureDashBoardPieChartLegend.ScienceKs1Unknown
    break;
  default: name = str;
    break;
  }
  return name;
}

export { CheckAppliedFilter, ComparisonNames, FillColor, FilterNames, SpecifyName, SpecifyPieChartName }